module.exports = __webpack_public_path__ + "img/profile-man-2-min.7fd1a1f2.jpg";